//Importaciones
import React, { useContext } from 'react';
import { Card, Row, Col } from "react-bootstrap"
import GAPElementTypeBox from '../GAPElementTypeBox';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../../../Common/CLabel';
import moment from 'moment';
import { ActionButton, DirectionalHint } from '@fluentui/react';
import LastEventsBox from '../LastEventsBox';
import { useState } from 'react';
import { __onGoToGapV2 } from '../../../../../../common/SystemRedirections';
import DialogGenerateGap from '../../../DialogGenerateGap';
import { useBoolean } from '@fluentui/react-hooks';
import { useGetGapDataseriePossiblesGaps } from '../../../../../../hooks/services/sKPI/useOfGAP';
import { __enum_PageMode, __enum_TeachGapPage, enum__BUTTONKEYS_KPI, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import MainAppContext from '../../../../../../MainAppContext';
import GapAppContext from '../../../../../../GapAppContext';
import { TeachBubbleMultiSteps } from '../../../../../Templates/TeachBubble/indexMultiSteps';

function GAPBox(props) {
    //Helpers
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);

    //Parametros de entrada.
    const {
        inputParam_GapRevisionsList=null,
        inputParam_SetGapRevisionsList=null,
        inputParam_GAPObject = null,
        inputParam_GapAnalyzeId = null,
        inputParam_SelectedElementId = null,
        InputParam_ElementList = null,
        inputParam_SetterSelectedElementId = null,
        inputParam_SetterGAPElements = null,
        inputParam_SetterStructurerevisionDataserieFullList = null,
        inputParam_SetterGapRevisionDataserieList = null,
        inputParam_FishboneList = null,
    } = props;


    //Parametros de componente.
    const [isLastEventPanelOpen, setIsLastEventPanelOpen] = useState(false);
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [gapAnalyzeList, setGapAnalyzeList] = useState(null);
    const [dataserieList, setDataserieList] = useState(null);
    const onOpenProcessGap = (e) => {
        showDialog()
    };
    const [processPosibleGapsConfig, setProcessPosibleGapsConfig] = useState(null);
    useGetGapDataseriePossiblesGaps(inputParam_SelectedElementId, inputParam_GapAnalyzeId, dataserieList, setDataserieList, setGapAnalyzeList, setProcessPosibleGapsConfig, isDialogVisible)

    const _priv_canReviewGap = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_SelectedElementId, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE)

    //Funciones de componente.
    const onOpenViewEventPanel = () => {
        setIsLastEventPanelOpen(true)
    }
    //Render de componente.
    return (
        <Card className='gap-element-form h-100'>
            <Row>
                <Col>
                    <Card.Header className='card-header-compact pt-1 pb-0 px-2'>
                        <Card.Title className="d-flex justify-content-between pb-0">
                            <b>{ t('data-lang-boxname-gap') }</b>
                            <TeachBubbleMultiSteps
                                inputParam_ButtonId={"btnHelp"}
                                inputParam_Title={t('data-lang-helptext-title')}
                                inputParam_ClassName="my-auto ms-auto"
                                inputParam_ButtonClassName="pb-2"
                                inputParam_DirectionalHint={DirectionalHint.topCenter}
                                inputParam_Steps={__enum_TeachGapPage.map(x => {return t(x)})}
                                inputParam_NextTechStepType={"GapPage"}
                            />
                            <div className='book-toolbar d-flex float-end'>
                                {
                                    (_priv_canReviewGap.value && _priv_canReviewGap.mode === __enum_PageMode.Edit) &&
                                    <ActionButton
                                        key={enum__BUTTONKEYS_KPI.PROCESS_GAP}
                                        id="btnGapReview"
                                        onClick={ () => onOpenProcessGap() }
                                        iconProps={{ iconName: 'ServerProcesses' }}
                                        title={inputParam_SelectedElementId === null ? t('data-lang-lbl-disabled'): null}
                                        allowDisabledFocus>
                                        { t('data-lang-btn-processgap') }
                                    </ActionButton>
                                }
                                {
                                    <ActionButton onClick={ () => onOpenViewEventPanel() } iconProps={{ iconName: 'View' }} allowDisabledFocus>
                                        { t('data-lang-lbl-viewevents') }
                                    </ActionButton>
                                }
                            </div>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="board-element-form-body pt-2 w-100">
                        {
                        inputParam_GAPObject.id !== null &&
                            <>
                                <Row>
                                    <Col>
                                        <Row className='d-none d-sm-flex'>
                                            <Col xl={12}>
                                                <CLabel labelText={ t('data-lang-lbl-name') } labelValue={ inputParam_GAPObject.name } />
                                            </Col>
                                            <Col xl={12}>
                                                <CLabel labelText={ t('data-lang-lbl-creationdate') } labelValue={ moment(inputParam_GAPObject.creationDate).format('DD/MM/YYYY') } />
                                            </Col>
                                            <Col xl={12}>
                                                <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ t('data-lang-skgap-status' + inputParam_GAPObject.statusId) } />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                    {
                                        InputParam_ElementList && /*inputParam_FishboneList &&*/
                                        <GAPElementTypeBox
                                            inputParam_EditMode={ true }
                                            inputParam_SelectedElementId={ inputParam_SelectedElementId }
                                            inputParam_ElementList={ InputParam_ElementList }
                                            inputParam_SetterGAPElements={inputParam_SetterGAPElements}
                                            inputParam_SetterSelectedElementId={inputParam_SetterSelectedElementId}
                                            inputParam_SetterStructurerevisionDataserieFullList={inputParam_SetterStructurerevisionDataserieFullList}
                                            inputParam_GAPId={inputParam_GAPObject.id}
                                            inputParam_FishboneList={inputParam_FishboneList}
                                            inputParam_ClickEnabled={true}
                                        />
                                    }
                                    </Col>
                                    {
                                        dataserieList && processPosibleGapsConfig && InputParam_ElementList &&
                                        <DialogGenerateGap
                                            inputParam_EditMode={false}
                                            inputParam_Element={InputParam_ElementList.find(x => x.elementId === inputParam_SelectedElementId)}//[##]
                                            inputParam_IsDialogOpen={isDialogVisible}
                                            inputParam_SetterIsDialogOpen={hideDialog}
                                            inputParam_DataserieList={dataserieList}
                                            inputParam_SetDataserieList={inputParam_SetterStructurerevisionDataserieFullList}
                                            inputParam_RevisionList={inputParam_GapRevisionsList}
                                            inputParam_SetRevisionList={inputParam_SetGapRevisionsList}
                                            inputParam_GapAnalyzeList={gapAnalyzeList}
                                            
                                            inputParam_ProcessPosibleGapsConfig={processPosibleGapsConfig}
                                            inputParam_SetProcessPosibleGapsConfig={setProcessPosibleGapsConfig}
                                        />
                                    }
                                </Row>
                            </>
                        }
                    </Card.Body>
                </Col>
            </Row>
            {
                isLastEventPanelOpen &&
                <LastEventsBox
                    inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                    inputParam_IsPanelOpen={isLastEventPanelOpen}
                    inputParam_SetterIsPanelOpen={setIsLastEventPanelOpen}
                />
            }
        </Card>
    );
}

///Proptypes
GAPBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_SelectedElementId: PropTypes.number,
    inputParam_GAPObject: PropTypes.object.isRequired,
    inputParam_SetterSelectedElementId: PropTypes.func.isRequired,
    inputParam_SetterGAPElements: PropTypes.func.isRequired,
    inputParam_SetterGapRevisionDataserieList: PropTypes.func.isRequired,
    inputParam_FishboneList: PropTypes.array,
};

export default GAPBox;